import { useContext } from 'react';
import { FeatureFlagContext } from './FeatureFlagContext';
/**
 * Returns whether the given feature flag is enabled for the current user.
 * Defaults to `false` while loading or if the flag is unknown.
 *
 * Accepts either a typed `FeatureFlagKey` or an arbitrary string (so we can
 * check flags that haven't been added to the union yet without blocking).
 */
export function useFeatureFlag(key) {
    const { flags } = useContext(FeatureFlagContext);
    return flags[key] === true;
}
/**
 * Escape hatch: read the full flag context (loading state, refetch, all flags).
 * Prefer `useFeatureFlag(key)` for single-flag checks.
 */
export function useFeatureFlags() {
    return useContext(FeatureFlagContext);
}
